import { throttle } from 'lodash';

// 使いまわせる関数
/**
 * 相対パスを返す
 * @param {string} path - ページのパス
 * @returns {string} - 相対パス
 */
export const getRelativePath = (path) => {
  const directories = path.split('/').filter((directory) => directory !== '');
  const rootDepth = directories.length;

  return '../'.repeat(rootDepth).replace(/\.\.\//, '');
};

/**
 * トグル挙動（クラスの付け替え）
 * @param {NodeList} element - クリックイベントを付与する要素
 * @param {boolean} needFixed - bodyを固定するかどうか
 */
export const toggleClass = (element, needFixed) => {
  element.addEventListener('click', () => {
    const targetId = element.getAttribute('data-target');
    const target = document.getElementById(targetId);
    if (target) {
      target.classList.toggle('is-active');
      if (!needFixed) return;
      if (target.classList.contains('is-active')) {
        document.body.classList.add('is-fixed');
      } else {
        document.body.classList.remove('is-fixed');
      }
    }
  });
};

/**
 * トグル挙動（スナックバー用）
 * @param {NodeList} element - クリックイベントを付与する要素
 */
export const toggleSnackbar = (element) => {
  element.addEventListener('click', () => {
    const targetId = element.getAttribute('data-snackbar');
    const target = document.getElementById(targetId);
    if (target) {
      target.classList.toggle('is-active');
    }
  });
};

/**
 * タブ風のラジオボタン切り替え
 * @param {NodeList} element - クリックイベントを付与する要素
 */
export const changeTabRadio = (element) => {
  element.addEventListener('change', (event) => {
    const targetId = element.getAttribute('data-target');
    const target = document.getElementById(targetId);
    const tabContents = document.querySelectorAll('.js-tabContent');

    if (target) {
      tabContents.forEach((tabContent) => {
        tabContent.classList.remove('is-active');
      });
      target.classList.toggle('is-active');
    }
  });
};

/**
 * トグル挙動（高さの切り替え）
 * @param {NodeList} element - クリックイベントを付与する要素
 * @param {number} setHeight - プルダウンが閉じた状態の高さを指定する場合
 */
export const toggleHeight = (element, setHeight) => {
  const minHeight = setHeight ? setHeight : 0;

  element.addEventListener('click', () => {
    const targetId = element.getAttribute('data-target');
    const target = document.getElementById(targetId);
    if (target) {
      if (target.clientHeight !== 0) {
        target.style.height = target.clientHeight + 'px';
      }
      target.clientHeight === minHeight ? (target.style.height = target.scrollHeight + 'px') : (target.style.height = minHeight + 'px');
      element.classList.toggle('is-active');

      // プルダウンは0.3秒で開くため、0.3秒後にクラスを付与
      if (target.classList.contains('is-active')) {
        target.classList.remove('is-active');
      } else {
        setTimeout(() => {
          target.classList.toggle('is-active');
        }, 300);
      }
    }
  });
};

/** セレクトボックス関連の制御 */
/**
 * フォーカスが外れたらセレクトボックスを閉じる
 * @param {NodeList} element - フォーカスイベントを付与する要素
 */
export const closeSelect = (element) => {
  element.addEventListener('blur', () => {
    const targetId = element.getAttribute('data-target');
    const target = document.getElementById(targetId);
    if (target) {
      target.classList.remove('is-active');
    }
  });
};

/**
 * セレクトボックスを開く
 * @param {NodeList} element - クリックイベントを付与する要素
 */
export const openSelect = (element) => {
  element.addEventListener('click', () => {
    const targetId = element.getAttribute('data-target');
    const target = document.getElementById(targetId);
    if (target) {
      target.classList.toggle('is-active');
    }
  });
};

/**
 * 選択された値を取得し表示する
 * @param {string} name - セレクトボックスのname属性
 */
export const selectValue = (name) => {
  const select = document.querySelector('input[type="radio"][name="' + name + '"]:checked');
  const parent = select.closest('.c-select__option-container');

  const textBox = parent.parentElement.querySelector('.c-select__label');
  textBox.innerHTML = select.value;
  textBox.classList.remove('c-select__label--placeholder');
};

/**
 * 選択された値を取得し表示する
 * @param {string} addressContainer - 住所選択領域(自宅・住所1,2)
 * @param {string} name - セレクトボックスのname属性
 */
export const selectAddressValue = (addressContainer, name) => {
  const select = addressContainer.querySelector('input[type="radio"][name="' + name + '"]:checked');
  const parent = select.closest('.c-select__option-container');

  const textBox = parent.parentElement.querySelector('.c-select__label');
  textBox.innerHTML = select.value;
  textBox.classList.remove('c-select__label--placeholder');
};

/**
 * name属性ごとにフォームをクリア
 * @param {NodeList} element - クリックイベントを付与する要素
 */
export const clearInputByName = (element) => {
  element.addEventListener('click', () => {
    const name = element.getAttribute('data-name');
    const checkboxes = document.querySelectorAll('input[type="checkbox"][name="' + name + '"]');
    if (checkboxes.length > 0) {
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    }
    const selectedRadio = document.querySelectorAll('input[type="radio"][name^="' + name + '"]:checked');
    if (selectedRadio.length > 0) {
      selectedRadio.forEach((radio) => {
        radio.checked = false;
        const parent = radio.closest('.c-select__option-container');

        if (parent) {
          const textBox = parent.parentElement.querySelector('.c-select__label');
          textBox.innerHTML = '';
          textBox.classList.remove('c-select__label--placeholder');
        }
      });
    }
    const input = document.querySelectorAll('input[type="text"][name^="' + name + '"]');
    if (input.length > 0) {
      input.forEach((input) => {
        input.value = '';
      });
    }
    const select = document.querySelectorAll('select[name^="' + name + '"]');
    if (select.length > 0) {
      select.forEach((select) => {
        select.selectedIndex = 0;
      });
    }
  });
};

/**
 * 指定フォーム中の全ての入力をクリア
 * @param {Node} form - クリアする対象のフォーム
 */
export const clearAllInput = (form) => {
  if (!form) return;
  const checkboxes = form.querySelectorAll('input[type="checkbox"]');
  if (checkboxes) {
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
  }
  const input = form.querySelectorAll('input[type="text"]');
  if (input) {
    input.forEach((input) => {
      input.value = '';
    });
  }
  const select = form.querySelectorAll('select');
  if (select) {
    select.forEach((select) => {
      select.selectedIndex = 0;
    });
  }
  const selectedRadio = form.querySelectorAll('input[type="radio"]:checked');
  if (selectedRadio.length > 0) {
    selectedRadio.forEach((radio) => {
      radio.checked = false;
      const parent = radio.closest('.c-select__option-container');
      if (!parent) return;

      const textBox = parent.parentElement.querySelector('.c-select__label');
      if (textBox) {
        textBox.innerHTML = '';
        textBox.classList.remove('c-select__label--placeholder');
      }
    });
  }
};

/**
 * 2重プルダウン制御
 * @param {NodeList} element - 発火する要素
 * @param {number} minHeight - プルダウンが閉じた状態の高さを指定
 */
export const doublePullDown = (element, minHeight) => {
  element.addEventListener('click', () => {
    if (element.parentElement.style.length > 0 || element.parentElement.hasAttribute('style')) {
      element.parentElement.removeAttribute('style');
    } else {
      element.parentElement.parentElement.removeAttribute('style');
    }
    const targetId = element.getAttribute('data-target');
    const target = document.getElementById(targetId);

    if (target.clientHeight !== 0) {
      target.style.height = target.clientHeight + 'px';
    }

    if (target) {
      target.clientHeight === Number(minHeight) ? (target.style.height = target.scrollHeight + 'px') : (target.style.height = minHeight + 'px');
      element.classList.toggle('is-active');
    }

    if (target.classList.contains('is-active')) {
      target.classList.remove('is-active');
    } else {
      setTimeout(() => {
        target.classList.toggle('is-active');
      }, 300);
    }
  });
};

/**
 * スクロールイベント
 * イベントの頻発を抑えるためにthrottleを使用（200ms）
 * @param {number} lastScroll - 前回のスクロール位置
 */
let isFirst = true;
const headerContainer = document.getElementById('js-headerContainer');
const topNavigation = document.querySelectorAll('.js-topNavigation');

const handleHeaderFixed = () => {
  headerContainer.classList.remove('is-hidden');
  headerContainer.classList.add('is-fixed');
};
const handleHeaderHidden = () => {
  headerContainer.classList.remove('is-fixed');
  headerContainer.classList.add('is-hidden');
};
const handleNavFixed = () => {
  topNavigation.forEach((element) => {
    element.classList.remove('is-hidden');
    element.classList.add('is-fixed');
  });
};
const handleNavHidden = () => {
  topNavigation.forEach((element) => {
    element.classList.remove('is-fixed');
    element.classList.add('is-hidden');
  });
};

export const handleScroll = _.throttle((lastScroll) => {
  if (!headerContainer) return;
  const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
  const isScrollingUp = lastScroll > currentScroll;

  if (currentScroll === 0) {
    handleHeaderFixed();
    if (topNavigation.length > 0) {
      handleNavFixed();
    }
    return;
  }

  if (isScrollingUp) {
    handleHeaderFixed();
    if (topNavigation.length > 0) {
      handleNavFixed();
    }
  } else if (!isFirst && !isScrollingUp && currentScroll > 240) {
    handleHeaderHidden();
  }

  if (topNavigation.length > 0 && !isFirst && !isScrollingUp && currentScroll > 100) {
    handleNavHidden();
  }

  isFirst = false;
  return currentScroll;
}, 200);

/**
 * パスワードの表示・非表示を切り替える
 * @param {HTMLElement} btn_pass - パスワード表示ボタン
 * @param {HTMLInputElement} input_pass - パスワード入力欄
 */
export const togglePasswordVisibility = (btn_pass, input_pass) => {
  if (input_pass.type === 'password') {
    input_pass.type = 'text';
    btn_pass.textContent = '隠す';
  } else {
    input_pass.type = 'password';
    btn_pass.textContent = '表示する';
  }
};

/**
 * 遅延実行
 * @param {Function} func
 * @param {Number} delay
 * @returns
 */
export const debounce = (func, delay) => {
  let inDebounce;

  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
};

/**
 * 三点リーダー省略つけはずし
 * @param {string} targetId
 * @param {HTMLElement} buttonElement
 * @returns
 */
export const toggleEllipsisClass = (targetId, buttonElement) => {
  const toggleEllipsisParagraph = document.getElementById(targetId);
  const toggleShowElements = document.getElementsByClassName(targetId);

  if (!toggleEllipsisParagraph || !buttonElement) return;
  buttonElement.addEventListener('click', () => {
    buttonElement.style.display = 'none';
    toggleEllipsisParagraph.classList.toggle('disable-ellipsis');
    Array.from(toggleShowElements).forEach((element) => element.classList.toggle('js-show'));
  });
};

const getCookie = (name) => {
  const cookies = document.cookie.split('; ');
  const found = cookies.find((c) => c.startsWith(name + '='));
  return found ? found.split('=')[1] : null;
};

const showSearchHistory = () => {
  const raw = decodeURIComponent(getCookie('searchHistory') || '[]');
  const history = JSON.parse(raw);

  const suggestWordsUl = document.querySelector('.js-suggestList');
  suggestWordsUl.innerHTML = '';

  // 検索履歴のカテゴリはセレクトボックスで選択中のものを使用
  const catVal = document.querySelector("input[name='cname']:checked")?.dataset.value || '';

  history.forEach((word) => {
    const safeWord = encodeURIComponent(word);
    const safeCatVal = encodeURIComponent(catVal);
    // <li> 要素作成
    const li = document.createElement('li');
    li.className = 'c-search-input__list';
    // <a> 要素作成
    const a = document.createElement('a');
    a.href = `/cmdtyallsearch?word=${safeWord}&cat=${safeCatVal}`;
    const span = document.createElement('span');
    span.className = 'c-search-input__list-text js-searchHistory';
    span.textContent = word;
    a.appendChild(span);
    // <button> 要素作成
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'c-search-input__delete-button js-suggest-delete';
    button.dataset.value = word;
    const img = document.createElement('img');
    img.src = '/img/close_black_icon.svg';
    img.alt = '削除';
    button.appendChild(img);
    // li要素にaタグとbuttonを入れる
    li.appendChild(a);
    li.appendChild(button);
    suggestWordsUl.appendChild(li);
  });

  document.querySelectorAll('.js-suggest-delete').forEach((ele) => {
    ele.addEventListener('click', () => {
      deleteSuggestWord(ele.dataset.value, ele);
    });
  });
};

export const searchForm = () => {
  // 検索フォーム挙動
  const searchInput = document.querySelectorAll('.js-searchForm');
  if (searchInput.length > 0) {
    searchInput.forEach((element) => {
      const form = element.closest('form');
      const deleteButton = form.querySelector('.js-searchInputDelete');

      if (element.value !== '' && deleteButton) {
        deleteButton.style.display = 'flex';
      }

      // 検索フォームにフォーカスが当たったら、モーダル表示
      element.addEventListener('focus', () => {
        element.classList.add('is-active');
        form.classList.add('is-active');
        document.body.classList.add('is-fixed');
        // 検索ワードが空だった場合検索履歴追加
        if (element.value === '') {
          showSearchHistory();
        }
      });

      // 検索フォームにフォーカスが外れたら、モーダル非表示(検索ボタンのクリックイベントがあるため遅延)
      element.addEventListener('blur', () => {
        setTimeout(() => {
          element.classList.remove('is-active');
          form.classList.remove('is-active');
          document.body.classList.remove('is-fixed');
        }, 100);
      });

      // 検索フォームの値が変更されたら、候補表示用のスタイル
      element.addEventListener(
        'input',
        debounce(() => {
          if (element.value !== '') {
            form.querySelector('.js-searchResult').classList.add('is-active');
            if (!deleteButton) return;
            deleteButton.style.display = 'flex';
            const suggestWordsUl = document.querySelector('.js-suggestList');
            const newItems = [];

            // サジェストAPIをコールする
            fetch(`/api/suggest?q_word=${element.value}`)
              .then((data) => data.json())
              .then((res) => {
                // 戻ってきた値を埋め込む
                res.ctgry.forEach((item, index) => {
                  // 5個まで
                  if (index > 4) {
                    return;
                  }
                  const li = document.createElement('li');
                  li.classList.add('c-search-input__list');

                  // サジェストがカテゴリ未指定のものはセレクトボックスで選択中のカテゴリを使用
                  const catVal = document.querySelector("input[name='cname']:checked")?.dataset.value || '';
                  const ctgryCd = item.ctgrycode.length === 0 ? catVal : item.ctgrycode;

                  li.innerHTML = `
                      <a href="/cmdtyallsearch?word=${item.keyword}&cat=${ctgryCd}">
                        <p class="c-search-input__list-text js-searchHistory">
                          <span>${item.keyword}</span>
                          <br>
                          <span class="c-search-input__list-category">カテゴリ：${item.ctgryname}</span>
                        </p>
                      </a>
                  `;
                  newItems.push(li);
                });
                res.word.forEach((item, index) => {
                  // 5個まで
                  if (index > 4) {
                    return;
                  }
                  const li = document.createElement('li');
                  li.classList.add('c-search-input__list');

                  // サジェストがカテゴリ未指定のものはセレクトボックスで選択中のカテゴリを使用
                  const catVal = document.querySelector("input[name='cname']:checked")?.dataset.value || '';

                  li.innerHTML = `
                      <a href="/cmdtyallsearch?word=${item.keyword}&cat=${catVal}">
                        <span class="c-search-input__list-text js-searchHistory">${item.keyword}</span>
                      </a>
                  `;
                  newItems.push(li);
                });

                suggestWordsUl.innerHTML = '';
                newItems.forEach((item) => {
                  suggestWordsUl.appendChild(item);
                });
              });
          } else {
            form.querySelector('.js-searchResult').classList.remove('is-active');
            showSearchHistory();
            if (!deleteButton) return;
            deleteButton.style.display = 'none';
          }
        }, 200),
      );

      // フォームクリアボタンの挙動
      if (deleteButton) {
        deleteButton.addEventListener('click', () => {
          element.value = '';
          form.querySelector('.js-searchResult').classList.remove('is-active');
          deleteButton.style.display = 'none';
        });
      }
    });
  }
};

/**
 * 都道府県セレクトボックスの中身を生成
 */
export const setPrefecturesSelect = () => {
  // prettier-ignore
  const prefectures = [
    {"id": "1", "name": "北海道"}, {"id": "2", "name": "青森県"}, {"id": "3", "name": "岩手県"}, 
    {"id": "4", "name": "宮城県"}, {"id": "5", "name": "秋田県"}, {"id": "6", "name": "山形県"}, 
    {"id": "7", "name": "福島県"}, {"id": "8", "name": "茨城県"}, {"id": "9", "name": "栃木県"}, 
    {"id": "10", "name": "群馬県"},{"id": "11", "name": "埼玉県"},{"id": "12", "name": "千葉県"},
    {"id": "13", "name": "東京都"},{"id": "14", "name": "神奈川県"},{"id": "15", "name": "新潟県"},
    {"id": "16", "name": "富山県"},{"id": "17", "name": "石川県"},{"id": "18", "name": "福井県"},
    {"id": "19", "name": "山梨県"},{"id": "20", "name": "長野県"},{"id": "21", "name": "岐阜県"},
    {"id": "22", "name": "静岡県"},{"id": "23", "name": "愛知県"},{"id": "24", "name": "三重県"},
    {"id": "25", "name": "滋賀県"},{"id": "26", "name": "京都府"},{"id": "27", "name": "大阪府"},
    {"id": "28", "name": "兵庫県"},{"id": "29", "name": "奈良県"},{"id": "30", "name": "和歌山県"},
    {"id": "31", "name": "鳥取県"},{"id": "32", "name": "島根県"},{"id": "33", "name": "岡山県"},
    {"id": "34", "name": "広島県"},{"id": "35", "name": "山口県"},{"id": "36", "name": "徳島県"},
    {"id": "37", "name": "香川県"},{"id": "38", "name": "愛媛県"},{"id": "39", "name": "高知県"},
    {"id": "40", "name": "福岡県"},{"id": "41", "name": "佐賀県"},{"id": "42", "name": "長崎県"},
    {"id": "43", "name": "熊本県"},{"id": "44", "name": "大分県"},{"id": "45", "name": "宮崎県"},
    {"id": "46", "name": "鹿児島県"},{"id": "47", "name": "沖縄県"},
  ]

  const prefecturesSelectTarget = document.querySelectorAll('[id^="js-addressPrefectures"]');
  if (!prefecturesSelectTarget.length === 0) return;

  let num = 0;

  if (prefecturesSelectTarget.length > 1) {
    prefecturesSelectTarget.forEach((prefecturesSelect) => {
      const inputName = prefecturesSelect.getAttribute('data-name') || 'prefecture';
      const prefecturesOption = prefectures.forEach((data) => {
        const option = `
        <div>
          <input type="radio" name="${inputName}" value="${data.name}" id="prefecture${data.id}-${num}" class="js-selectOption-address" />
          <label class="c-select__options" for="prefecture${data.id}-${num}">${data.name}</label>
        </div>
      `;
        prefecturesSelect.insertAdjacentHTML('beforeend', option);
        num += 1;
      });
    });
  }
  if (prefecturesSelectTarget.length === 1) {
    prefecturesSelectTarget.forEach((prefecturesSelect) => {
      const inputName = prefecturesSelect.getAttribute('data-name') || 'prefecture';
      const prefecturesOption = prefectures.forEach((data) => {
        const option = `
        <div>
          <input type="radio" name="${inputName}" value="${data.name}" id="prefecture${data.id}" class="js-selectOption" />
          <label class="c-select__options" for="prefecture${data.id}">${data.name}</label>
        </div>
      `;
        prefecturesSelect.insertAdjacentHTML('beforeend', option);
      });
    });
  }
};

/**
 * お気に入り登録/削除ボタン
 * @param {*} button
 */
export const favButton = (button) => {
  // 初期表示状態を制御（リストに商品コードが含まれていたらselected）
  const cmdtyCode = button.value;
  // TODO お気に入りリストのセッション格納の共通化
  if (typeof favCmdtyCodes !== 'undefined' && favCmdtyCodes?.includes(cmdtyCode)) {
    button.classList.add('c-favorite__button--selected');
    button.setAttribute('data-target', 'js-delfav');
  }
  // クリック時の動作
  button.addEventListener('click', () => {
    // 非活性化
    button.disabled = true;
    const hasSelected = button.classList.contains('c-favorite__button--selected');
    const data = { cmdtyCode: cmdtyCode };
    const option = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    };
    // URL切り替え
    const url = hasSelected ? '/api/favorite/delete' : '/api/favorite/add';

    // zetaタグ関数呼び出し
    try {
      const product = '{"sku":"' + cmdtyCode + '","quantity":1}';
      if (url === '/api/favorite/add') {
        zdAddToFavoriteAsync(product).then(() =>
          // お気に入り登録
          postFavorite(url, option, button),
        );
      } else {
        zdRemoveFromFavoriteAsync(product).then(() =>
          // お気に入り削除
          postFavorite(url, option, button),
        );
      }
    } catch (error) {
      console.log(error);
      // お気に入り登録/削除
      postFavorite(url, option, button);
    }
  });
};

/**
 * zetaタグ関数呼び出し後のお気に入り登録/削除API
 */
export const postFavorite = (url, option, button) => {
  // API実行
  postWithCsrf(url, option)
    .then((res) => {
      if (res.ok && !res.url.includes('login')) {
        // スナックバー表示
        const targetId = button.getAttribute('data-target');
        const target = document.getElementById(targetId);
        if (target) {
          target.classList.toggle('is-active');
          if (target.classList.contains('is-active')) {
            document.body.classList.add('is-fixed');
          } else {
            document.body.classList.remove('is-fixed');
          }
        }
        // クラス切り替え
        button.classList.toggle('c-favorite__button--selected');
        if ('js-addfav' === button.getAttribute('data-target')) {
          button.setAttribute('data-target', 'js-delfav');
        } else {
          button.setAttribute('data-target', 'js-addfav');
        }
        // 活性化
        button.disabled = false;
      } else if (res.url.includes('login')) {
        // お気に入り登録＆一覧表示に遷移
        const addForm = document.createElement('form');
        addForm.action = '/mypage/myfavorite/add';
        addForm.method = 'GET';

        document.body.append(addForm);

        const input = document.createElement('input');
        const cmdtyCode = button.value;
        input.type = 'hidden';
        input.setAttribute('name', 'cmdtyCode');
        input.setAttribute('value', cmdtyCode);
        addForm.appendChild(input);

        addForm.submit();
      }
    })
    .catch((reason) => {
      // TODO エラー時の処理が必要
      console.log(reason);
    });
};

/**
 * お気に入り登録/削除ボタン
 * @param {*} button
 */
export const addFavoriteCartDeleteClass = (button) => {
  // クリック時の動作
  button.addEventListener('click', () => {
    // 非活性化
    const cmdtyCode = button.value;
    button.disabled = true;
    const data = { cmdtyCode: cmdtyCode };
    const option = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    };

    // zetaタグ関数呼び出し
    try {
      const product = '{"sku":"' + cmdtyCode + '","quantity":1}';
      Promise.all([zdRemoveFromCartAsync(product), zdAddToFavoriteAsync(product)]).then(() =>
        // お気に入り登録&カート削除
        postFavoriteCartDelete(option, button),
      );
    } catch (error) {
      console.log(error);
      // お気に入り登録&カート削除
      postFavoriteCartDelete(option, button);
    }
  });
};

/**
 * zetaタグ関数呼び出し後のお気に入り登録&カート削除API
 */
export const postFavoriteCartDelete = (option, button) => {
  // API実行
  postWithCsrf('/api/addFavoriteDeleteCart', option)
    .then((res) => {
      if (res.ok && !res.url.includes('login')) {
        // 活性化
        button.disabled = false;
        location.reload();
      } else if (res.url.includes('login')) {
        // ログイン後、Getでお気に入り追加とカートからの削除を行う処理を呼び出す
        // リダイレクトでカートを表示
        const addForm = document.createElement('form');
        addForm.action = '/purchase/addFavoriteDeleteCart';
        addForm.method = 'GET';

        document.body.append(addForm);

        const input = document.createElement('input');
        const cmdtyCode = button.value;
        input.type = 'hidden';
        input.setAttribute('name', 'cmdtyCode');
        input.setAttribute('value', cmdtyCode);
        addForm.appendChild(input);

        addForm.submit();
      }
    })
    .catch((reason) => {
      // TODO エラー時の処理が必要
      console.log(reason);
    });
};

/**
 * 入荷メール登録ボタン
 * @param {*} button
 */
export const incomingMailButton = (button) => {
  // クリック時の動作
  button.addEventListener('click', () => {
    // 非活性化
    const cmdtyCode = button.value;
    button.disabled = true;
    const data = { cmdtyCode: cmdtyCode };
    const option = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    };

    // API実行
    postWithCsrf('/api/incomingmail/add', option)
      .then((res) => {
        if (res.ok && !res.url.includes('login')) {
          // メッセージモーダル表示
          const targetId = button.getAttribute('data-target');
          const target = document.getElementById(targetId);
          if (target) {
            target.classList.toggle('is-active');
            if (target.classList.contains('is-active')) {
              document.body.classList.add('is-fixed');
            } else {
              document.body.classList.remove('is-fixed');
            }
          }

          // 活性化
          button.disabled = false;
        } else if (res.url.includes('login')) {
          // 入荷メール登録
          const addForm = document.createElement('form');
          addForm.action = '/mypage/incomingmaillist/add';
          addForm.method = 'GET';

          document.body.append(addForm);

          const input = document.createElement('input');
          input.type = 'hidden';
          input.setAttribute('name', 'cmdtyCode');
          input.setAttribute('value', cmdtyCode);
          addForm.appendChild(input);

          addForm.submit();
        }
      })
      .catch((reason) => {
        // TODO エラー時の処理が必要
        console.log(reason);
      });
  });
};

/**
 * 入荷メール登録者数取得処理
 * @param {*} el
 */
export const getIncomingMailRegistCount = (el) => {
  // クリック時の動作
  el.addEventListener('click', () => {
    const cmdtyCode = el.value;
    // API実行
    fetch(`/api/incomingmail/count/${cmdtyCode}`)
      .then((data) => data.json())
      .then((res) => {
        const incomingMailCountText = document.querySelector('.js-mailregistercount-text');
        incomingMailCountText.innerHTML = '';
        incomingMailCountText.innerHTML = `ただいま<span class="l-search__modal-text--bold l-search__modal-text--red">${res.count}人</span>が登録中`;
        document.querySelector('.js-incomingMailButton').value = cmdtyCode;
      })
      .catch((reason) => {
        // TODO エラー時の処理が必要
        console.log(reason);
      });
  });
};

/**
 * 予約情報領域の作成
 * @param {*} el
 */
export const createReserveRegion = (el) => {
  // クリック時の動作
  el.addEventListener('click', () => {
    const cmdtyCode = el.value;
    const reserveRegion = document.querySelector('.js-reserve-region');
    const reserveLimitIdElement = document.getElementById('reserveLimit');
    const reserveAmountIdElement = document.getElementById('reserveAmount');
    const reserveKindIdElement = document.getElementById('reserveKind');
    const reserveNewFullFlgIdElement = document.getElementById('reserveNewFullFlg');

    let reserveLimit, reserveAmount, reserveKind, reserveNewFullFlg;
    if (reserveLimitIdElement && reserveAmountIdElement && reserveKindIdElement && reserveNewFullFlgIdElement) {
      reserveLimit = reserveLimitIdElement.value;
      reserveAmount = reserveAmountIdElement.value;
      reserveKind = reserveKindIdElement.value;
      reserveNewFullFlg = reserveNewFullFlgIdElement.value;
    } else {
      reserveLimit = el.closest('.c-cassette').querySelector('.js-value-reserveLimit').value;
      reserveAmount = el.closest('.c-cassette').querySelector('.js-value-reserveAmount').value;
      reserveKind = el.closest('.c-cassette').querySelector('.js-value-reserveKind').value;
      reserveNewFullFlg = el.closest('.c-cassette').querySelector('.js-value-reserveNewFullFlg').value;
    }
    let insertOpt = [];
    insertOpt.push(`
    <p class="l-search__modal-heading">商品が入荷したら自動発送！</p>
    <p class="l-search__modal-text">
      入荷次第商品を確保するので安心です。<br />
      予約時より値下がりした場合は値下げ後の価格で購入できます。
    </p>
    `);
    // 予約可能
    if (Number(reserveLimit) > Number(reserveAmount) && !('01' === reserveKind && '1' === reserveNewFullFlg)) {
      insertOpt.push(`<a href="/reservation/reservationregist/${cmdtyCode}" class="c-button--reserve l-search__modal-button">予約する（予約金110円）</a>`);
      // 予約者0人
      if (Number(reserveAmount) === 0) {
        insertOpt.push(
          `<p class="l-search__modal-text">予約者<span class="l-search__modal-text--bold l-search__modal-text--red">0人</span><br />今すぐ予約で入荷次第発送します！</p>`,
        );
      } else {
        insertOpt.push(
          `<p class="l-search__modal-text js-reservecount-text">ただいま<span class="l-search__modal-text--bold l-search__modal-text--red">${reserveAmount}人</span>が予約中</p>`,
        );
      }
      if (Number(reserveLimit) === 9999 || '01' === reserveKind) {
        insertOpt.push(`<span class="l-search__modal-text--bold l-search__modal-text--red">新商品の予約受付中！</span><br />新商品をおトクな中古価格で予約できるチャンス！`);
      }
      // 予約満枠
    } else {
      insertOpt.push(`<button type="button" class="c-button--reserve l-search__modal-button" disabled>予約する（予約金110円）</button>`);
      insertOpt.push(`<p class="l-search__modal-text">
        <span class="l-search__modal-text--bold">ただいま予約は<span class="l-search__modal-text--red">満枠</span>です。</span>
        <br />
        入荷メールを登録で予約の再開をお知らせします。</p>`);
    }
    reserveRegion.innerHTML = '';
    reserveRegion.insertAdjacentHTML('beforeend', insertOpt.join(''));
  });
};

/**
 * 住所検索
 * @param {*} button
 */
export const searchAddress = (button, flag = false, event = 'click') => {
  // クリック時の動作
  button.addEventListener(event, () => {
    const container = button.closest('.js-addressContainer');
    const addressOptions = container.querySelector('[id^="js-addressPrefectures"]');
    const dataName = addressOptions.getAttribute('data-name');
    const addressRadio = addressOptions.querySelectorAll('input[type="radio"]');

    // 非活性化
    const yubin = container.querySelector('input[name="fullPostcode"]').value;
    button.disabled = true;
    const data = { yubin: yubin };
    const option = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    };
    console.log(option);

    // API実行
    postWithCsrf('/api/searchaddress', option)
      .then((res) => res.json())
      .then((data) => {
        const address2 = container.querySelector('input[name="address2"]');
        const address3 = container.querySelector('input[name="address3"]');
        const errorMessage = container.querySelector(flag ? '.address-error' : '.c-input-text__error-message');

        // フィールドをクリア
        errorMessage.innerHTML = '';

        if (data.errorMessage) {
          // エラーメッセージが存在する場合
          errorMessage.innerHTML = data.errorMessage;
          errorMessage.style.display = 'block';
        } else {
          // 住所情報を表示
          address2.value = data.address2; // 市区町村
          address3.value = '';
          errorMessage.style.display = 'none';

          addressRadio.forEach((radio) => {
            if (radio.value === data.address1) {
              radio.checked = true;
              selectAddressValue(container, dataName);
            }
          });
        }

        // ボタンを再度有効化
        button.disabled = false;
      })
      .catch((reason) => {
        // エラー時の処理
        const errorMessage = document.querySelector('.c-input-text__error-message');
        errorMessage.innerHTML = '住所の検索中にエラーが発生しました。';
        errorMessage.style.display = 'block';
        button.disabled = false;
      });
  });
};

/**
 * CSRFトークンを埋め込みつつAPI呼び出しする(fetch用)
 * @param {string} url URL
 * @param {Object} option fetchオプション
 * @returns Promise
 */
export const postWithCsrf = (url, option) => {
  const token = document.querySelector("meta[name='_csrf']")?.content;
  const header = document.querySelector("meta[name='_csrf_header']")?.content;

  option.headers[header] = token;
  return fetch(url, option);
};

/**
 * CSRFトークンを埋め込みつつAPI呼び出しする(ajax用)
 * @param {Object} option $.ajax呼び出し時のoption
 * @returns Promise
 */
export const postWithCsrfAjax = (option) => {
  const token = $("meta[name='_csrf']").attr('content');
  const header = $("meta[name='_csrf_header']").attr('content');

  $(document).ajaxSend(function (e, xhr, options) {
    xhr.setRequestHeader(header, token);
  });

  return $.ajax(option);
};

/**
 * 検索履歴削除ボタン処理
 * @param {*} word 該当の検索履歴
 * @param {*} element 当該要素
 */
export const deleteSuggestWord = (word, element) => {
  const raw = decodeURIComponent(getCookie('searchHistory') || '[]');
  let history = JSON.parse(raw);
  // Cookieの値から削除する
  history = history.filter((h) => h !== word);
  document.cookie = `searchHistory=${encodeURIComponent(JSON.stringify(history))}; path=/`;
  // 非表示化
  element.closest('.c-search-input__list').style.display = 'none';
};

/**
 * 検索履歴全削除ボタン処理
 */
export const deleteAllSuggestWord = () => {
  document.cookie = `searchHistory=; path=/`;
  const suggestWordsUl = document.querySelector('.js-suggestList');
  suggestWordsUl.innerHTML = '';
};

/**
 * チェックした商品を～する処理
 * @param {string} action 処理種別
 * @param {string[]} cmdtyCodeArr
 * @param {Function} onSuccess
 * @param {Function} onError
 */
export const bulkGoAction = (action = '', cmdtyCodeArr = [], onSuccess = (message) => {}, onError = (e) => {}) => {
  const cmdtyCodesStr = cmdtyCodeArr?.join(',') || '';
  const data = { cmdtyCodes: cmdtyCodesStr };
  const option = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };

  switch (action) {
    case 'cart':
      try {
        // zetaタグ関数呼び出し
        cmdtyCodeArr.forEach((cmdtyCode) => {
          const product = '{"sku":"' + cmdtyCode + '","quantity":1}';
          zdAddToCart(product);
        });
        // カート追加
        postAddCarts(option, onSuccess, onError);
      } catch (error) {
        console.log(error);
        // カート追加
        postAddCarts(option, onSuccess, onError);
      }
      break;
    case 'add-incomingmail':
      // API実行
      postWithCsrf('/api/incomingmail/addbulk', option)
        .then((response) => response.text())
        .then((text) => {
          if (!isNaN(text)) {
            onSuccess(`${text}点を入荷メールに登録しました。`);
          } else {
            onError();
          }
        })
        .catch((reason) => {
          onError(reason);
        });
      break;
    case 'delete-incomingmail':
      // API実行
      postWithCsrf('/api/incomingmail/deletebulk', option)
        .then((response) => response.text())
        .then((text) => {
          if (!isNaN(text)) {
            onSuccess(`${text}点を入荷メールから削除しました。`);
          } else {
            onError();
          }
        })
        .catch((reason) => {
          onError(reason);
        });
      break;
    case 'on-pricedownmail':
      // API実行
      postWithCsrf('/api/favorite/pricedownemailflag/addbulk', option)
        .then((response) => response.text())
        .then((text) => {
          if (!isNaN(text)) {
            //location.reload();
            window.location.href = '/mypage/myfavorite';
          } else {
            onError();
          }
        })
        .catch((reason) => {
          onError(reason);
        });
      break;
    case 'off-pricedownmail':
      // API実行
      postWithCsrf('/api/favorite/pricedownemailflag/deletebulk', option)
        .then((response) => response.text())
        .then((text) => {
          if (!isNaN(text)) {
            // location.reload();
            window.location.href = '/mypage/myfavorite/';
          } else {
            onError();
          }
        })
        .catch((reason) => {
          onError(reason);
        });
      break;
    case 'delete-fav':
      try {
        // zetaタグ関数呼び出し
        cmdtyCodeArr.forEach((cmdtyCode) => {
          const product = '{"sku":"' + cmdtyCode + '","quantity":1}';
          zdRemoveFromFavorite(product);
        });
        // お気に入り一括削除
        postDeleteFavoriteBulk(option, onError);
      } catch (error) {
        console.log(error);
        // お気に入り一括削除
        postDeleteFavoriteBulk(option, onError);
      }
      break;
    default:
      onError({});
      break;
  }
};

/**
 * zetaタグ関数呼び出し後のカート追加API
 */
export const postAddCarts = (option, onSuccess, onError) => {
  // API実行
  postWithCsrf('/api/addcarts', option)
    .then((response) => response.json()) // JSONレスポンスをパース
    .then((data) => {
      const snackbar = document.getElementById('js-addcart-ng');
      if (snackbar) {
        snackbar.classList.remove('is-active');
      }
      if (data.status === 'ok') {
        // バッジ更新
        const cartCountBadge = document.querySelector('.js-cartcount');
        const totalProductsCount = data.data.totalProducts;
        if (cartCountBadge) {
          cartCountBadge.innerHTML = parseInt(totalProductsCount);
        } else {
          document.querySelector('.js-cartcontainer').insertAdjacentHTML(
            'beforeend',
            `
              <span class="l-header-common__nav-list__active l-header-common__nav-list__active-count js-cartcount">${totalProductsCount}</span>
              `,
          );
        }
        onSuccess(`${data.message}点をカートに追加しました。`);
      } else if (data.status === 'ng') {
        // カートに入れる際にエラー発生
        //onError('${data.message}');
        if (snackbar) {
          // messageをスナックバーに設定する
          snackbar.querySelector('.c-snackbar__text').innerText = data.message;
          snackbar.classList.toggle('is-active');
        }
        throw new Error(data.message);
      } else {
        onError('不明なレスポンスが返されました。');
      }
    })
    .catch((reason) => {
      onError(reason);
    });
};

/**
 * zetaタグ関数呼び出し後のお気に入り一括削除API
 */
export const postDeleteFavoriteBulk = (option, onError) => {
  // API実行
  postWithCsrf('/api/favorite/deletebulk', option)
    .then((response) => response.text())
    .then((text) => {
      if (!isNaN(text)) {
        // 現在のURLにパラメータを追加してリロード
        var currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('responseCount', text);
        currentUrl.searchParams.set('processType', 'delete-fav');
        window.location.href = currentUrl.toString();

        //onSuccess(`${text}点をお気に入りから削除しました。`);
      } else {
        onError();
      }
    })
    .catch((reason) => {
      onError(reason);
    });
};

/**
 * クレカ選択時に支払い方法もONにする
 */
export const enablePayRadioWhenCardSelect = () => {
  const cards = document.querySelectorAll('.js-card-select-radio');
  if (cards && cards.length > 0) {
    cards.forEach((ele) => {
      ele.addEventListener('click', () => {
        document.getElementById('credit').checked = true;
        const creditPayButton = document.getElementById('creditPayButton');
        const rakutenPayButton = document.getElementById('rakutenPayButton');
        if (creditPayButton && rakutenPayButton) {
          creditPayButton.style.display = 'block';
          rakutenPayButton.style.display = 'none';
        }
      });
    });
  }
};
